import { render, staticRenderFns } from "./Techno.vue?vue&type=template&id=13207fba&"
import script from "./Techno.vue?vue&type=script&lang=js&"
export * from "./Techno.vue?vue&type=script&lang=js&"
import style0 from "./Techno.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports